import React from 'react'
import PropTypes from 'prop-types'
import Panel from 'common/components/Panel'
import actions from '../actions'
import Resource from 'src/common/components/Resource'
import CategoriesForm from '../categoriesForm'

const handleSubmit = id => async (values, form) => {
  const { name } = values
  const { setSubmitting, setErrors, setStatus } = form
  try {
    await actions.update(id, { name })
    setStatus({ success: true })
  } catch (e) {
    setErrors({ http: e.message })
  }
  setSubmitting(false)
}

const CreateCategory = ({ match }) => (
  <Panel title='Edit Category'>
    <Resource
      name='categories'
      resourceId={match.params.id}
      render={category => (
        <CategoriesForm
          isEdit
          handleSubmit={handleSubmit(match.params.id)}
          initialValues={{name: category.name || ''}}
        />
      )}
    />
  </Panel>
)

CreateCategory.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired
    }).isRequired
  }).isRequired
}

export default CreateCategory
